import React from 'react';
import * as Styled from './styled';
export const VirtualProductThumbnail = ({ symbol = '$', size = 'medium', }) => (React.createElement(Styled.Container, { size: size, "aria-label": "Virtual Product Thumbnail" }, symbol));
